import {Component, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../services/role.service';
import {MatTableGeneratorComponent} from '../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../table-datasouces/multi-crud.datasource';
import {Customer} from '../../dto/customer';
import {formatPhoneNumeric, phoneToCountry, toDateString} from '../../providers/app-date-adapter';
import {FormControl} from '@angular/forms';
import {IdentStatus} from '../../dto/ident-status';
import {CompanyService} from '../services/company.service';
import {Company} from '../../dto/company';
import {EmailSendStatus} from '../../dto/order-status';
import {PepStatus} from '../../dto/pep-status';
import {CustomersOverviewService} from '../../services/customers-overview.service';
import {CustomerOverviewList} from '../../dto/customerOverviewList';
import {byNumeric} from 'iso-country-codes';
import {FileHelper} from "../../helpers/file-helper";
import {CardsService} from "../services/cards.service";
import {Country} from "../../dto/country";
import {CountryService} from "../../services";
import {ContentRowComponent, ContentRowField} from "../../shared/content-row/content-row.component";
import {CashbackGroupMembership} from "../../dto/cashbackGroup";

@Component({
  selector: 'app-customers-overview',
  templateUrl: './customers-overview.component.html',
  styleUrls: ['./customers-overview.component.css']
})
export class CustomersOverviewComponent {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private customersOverviewService: CustomersOverviewService,
    public companiesService: CompanyService,
    private countryService: CountryService,
    private cardsService: CardsService,

  ) { }



  public webIdStatusSelect = new FormControl();
  public companySelect = new FormControl();
  public countriesSelect = new FormControl();
  public companies: Company[];
  public countries: Country[];
  public webIdStatus = IdentStatus;
  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  dataSource = new MultiCrudDataSource(this.customersOverviewService);
  columns = [

    { columnDef: 'title', header: 'Title', cell: row => `${row.title}` } as ContentRowField<CustomerOverviewList>,
    { columnDef: 'isIdentified', sortable: false, header: '',
      cellColor: (row: CustomerOverviewList) => {

        if ( row.pepStatus == PepStatus.confirmedMatch ) {
          return 'red';
        }
        if ( row.pepStatus == PepStatus.possibleMatch ) {
          return 'orangered';
        }

        if ( row.identStatus == IdentStatus.success ) {
          return '#8bc34a';
        }
        if ( row.identStatus == IdentStatus.fail ) {
          return 'red';
        }

        return false;
      },
      icon: (row: CustomerOverviewList) => {
        if ( row.pepStatus == PepStatus.possibleMatch || row.pepStatus == PepStatus.confirmedMatch ) {
          return 'report_problem';
        }

        if ( row.identStatus == IdentStatus.success ) {
          return 'beenhere';
        }
        if ( row.identStatus == IdentStatus.fail ) {
          return 'beenhere';
        }

        return false;
      }},
    { columnDef: 'firstName', header: 'First name', cell: (row: CustomerOverviewList) => `${row.firstName}` },
    { columnDef: 'lastName', header: 'Last name', cell: (row: CustomerOverviewList) => `${row.lastName}` },
    { columnDef: 'address', header: 'Address', cell: (row: CustomerOverviewList) => `${row.address}` },
    { columnDef: 'city', header: 'City', cell: (row: CustomerOverviewList) => `${row.city}` },
    { columnDef: 'zipCode', header: 'Zip code', cell: (row: CustomerOverviewList) => `${row.zipCode}` },
    { columnDef: 'email', header: 'Email', cell: (row: CustomerOverviewList) => `${row.email}`, cellColor: (row: CustomerOverviewList) => {

        /*if ( row.emailSendStatus == EmailSendStatus.Undeliverable && row.emailRejectedCount >= 3) {
          return '#ff0000';
        }
        if ( row.emailSendStatus == EmailSendStatus.Undeliverable) {
          return '#ff9900';
        }*/

        return false;
      }
    },
    { columnDef: 'phone', header: 'Mobile', cellFlag: (row: CustomerOverviewList) => phoneToCountry(row.phone + ''), cell: (row: CustomerOverviewList) => `${formatPhoneNumeric(row.phone)}` },
    { columnDef: 'dob', header: 'Date of birth', cell: (row: CustomerOverviewList) => `${toDateString(row.dob)}` },
    { columnDef: 'Partner', header: 'Partner', cell: (row: CustomerOverviewList) => row.companyName ?? '' },
    { columnDef: 'partnerCustomerId', header: 'Partner-ID', cell: (row: CustomerOverviewList) => row.partnerCustomerId },
    { columnDef: 'countryIsoCode', header: 'Country', cell: (row: CustomerOverviewList) => {
      if ( row.countryIsoCode ) {
        return byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2;
      }
      return '';
    } },
    { sortable: false, columnDef: 'cardsCount', header: 'Cards', cell: ( row: CustomerOverviewList ) => {
      if ( row.cardIds != null ) {
        return row.cardIds.length;
      }
      return '-';
      } },

  ]  as ContentRowField<CustomerOverviewList>[];

  ngOnInit() {
    this.companiesService.getAll().subscribe( x => {
      this.companies = x.data;
    });
    this.countryService.getMany().subscribe(result => {
      this.countries = result.data;
    });

  }


  // WebIdEvent
  onWebStatusChange() {

    this.triggerSearch();
  }

  onCompanyChange() {
    this.table.filters.someAdditionalData = 'companyid_' + this.companySelect.value; // TODO heavy abuse
    this.triggerSearch();
  }

  onCountryChange() {
    this.table.filters.countriesFilter = this.countriesSelect.value as string[];
    this.triggerSearch();
  }

  triggerSearch() {
    this.onSearch();
  }

  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
    }
  }

  getPartnerId(row: Customer) {
    let r = '';
    let c = 0;
    const array = row.orders.filter(x => x.partnerCustomerId != null);
    const resArr = [];

    if (array.length > 0) {
      row.orders.forEach((item) => {
        const i = resArr.findIndex(x => x.partnerCustomerId == item.partnerCustomerId);
        if (i <= -1) {
          if (c > 0) {
            r = r + ', ';
          }
          resArr.push({id: item.id, name: item.partnerCustomerId});
          r = item.partnerCustomerId;
          c++;
        }

      });
    }


    return r == '' ? '-' : r;
  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  getViewLink = (item: Customer): string => item.id.toString();

  getEditLink = (item: Customer): string => item.id.toString() + '/edit';

  editEnabled() {
    return this.roleService.hasRoles('admin');
  }

  deleteEnabled() {
    return this.roleService.hasRoles('admin');
  }

  clearFilter() {
    this.webIdStatusSelect.patchValue(null);
    this.companySelect.patchValue(null);
    this.table.clearFilter();
  }

  currentUserIsIssuerExternal() {
    return this.roleService.hasRoles('issuer_external');
  }

  cardsExpiringSoonFile() {

    this.cardsService.cardsExpiringSoonFile()
      .subscribe(result => {
        FileHelper.saveFile(result);
      });
  }
}
